import React, { Component } from 'react';
import { AutoComplete } from 'antd';
import sort from 'alphanum-sort';

export class AddressAutoComplete extends Component {
  constructor() {
    super();
    this.state = {
      query: '',
      options: [],
      data: [],
      error: undefined
    };

    this.onSelect = this.onSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.autocompleteSearch = this.autocompleteSearch.bind(this);
  }

  onSelect(value) {
    const item = this.state.data.find(d => d.address === value);
    if (item) {
      this.props.onLoading();
      this.setState({ options: [item.address] });
      fetch(`api/print/${item.realEstate.uuid}/${item.realEstate.name}`)
        .then(response => {
          if (!response.ok) {
            throw response;
          }
          return response.json();
        })
        .then(data => {
          if (data.results[0] && !data.messages.length) {
            this.props.onSelectAddress(data.results[0].value.url);
          }
        })
        .catch(err => {
          err.text().then(errorMessage => {
            this.setState({
              data: undefined,
              options: []
            });
            this.props.onError(JSON.parse(errorMessage));
          });
        });
    }
  }

  clearSearch() {
    this.setState({
      options: [],
      data: undefined
    });
  }

  autocompleteSearch() {
    if (this.state.query === undefined || this.state.query.length === 0) {
      this.setState({ options: [] });
    } else {
      fetch(`api/address/${this.state.query}`)
        .then(response => {
          if (!response.ok) {
            throw response;
          }
          return response.json();
        })
        .then(data => {
          const addresses = data.map(address => {
            return {
              address: `${address.name}, ${address.postCode}, ${address.postCity}`,
              realEstate: {
                uuid: address.realEstateUUID,
                name: address.realEstateName
              }
            };
          });
          console.log(`setting state query="${this.state.query}", options=${addresses.length}`);
          this.setState({
            options: sort(addresses.map(a => a.address)),
            data: addresses
          });
        })
        .catch(err => {
          err.text().then(errorMessage => {
            this.setState({
              data: undefined,
              options: []
            });
            this.props.onError(JSON.parse(errorMessage));
          });
        });
    }
  }

  handleSearch = value => {
    this.setState({ query: value }, () => {
      if (this.state.query.length > 0) {
        this.autocompleteSearch();
      } else {
        this.clearSearch();
      }
    });
  };

  render() {
    return (
      <AutoComplete
        dataSource={this.state.query.length > 0 ? this.state.options : []}
        size="large"
        style={{ width: '100%' }}
        onSelect={this.onSelect}
        onSearch={this.handleSearch}
        placeholder="Skriv in er adress"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AddressAutoComplete.js